module.exports = __webpack_public_path__ + "static/media/finishRoutePin.570b2e95.png";